<template>
	<div class="container">
		<div class="m_sub_top">
			<div class="top_content">
				<h2 class="headline_m">
					{{ $t('rtr_personal-how-trade_and_cashback.title1') }}<br />
					{{ $t('rtr_personal-how-trade_and_cashback.title2') }}
				</h2>
				<p class="body_m">
					{{ $t('rtr_personal-how-trade_and_cashback.text1') }}<br />{{
						$t('rtr_personal-how-trade_and_cashback.text2')
					}}<br />{{ $t('rtr_personal-how-trade_and_cashback.text3') }}
				</p>
				<div class="button_area">
					<button
						class="button_bg_red mr_10"
						@click="$router.push({ name: 'auth-register' })"
					>
						{{ $t('button.signup') }}
					</button>
					<button class="button_bg_black" @click="notYet">
						{{ $t('button.down') }}
					</button>
				</div>
			</div>
		</div>
		<section class="content_area background">
			<div>
				<h2 class="headline_s fc_white mb_20">
					{{ $t('rtr_personal-how-trade_and_cashback.title3') }}
				</h2>
				<p class="body_m fc_gray">
					{{ $t('rtr_personal-how-trade_and_cashback.text4') }}<br />
					{{ $t('rtr_personal-how-trade_and_cashback.text5') }}
					{{ $t('rtr_personal-how-trade_and_cashback.text6') }}
				</p>
			</div>
		</section>
		<section>
			<div class="content_area pb_10">
				<div class="detail_area">
					<div class="detail">
						<h2 class="headline_s">
							{{ $t('rtr_personal-how-trade_and_cashback.title4') }}
							<br />
							{{ $t('rtr_personal-how-trade_and_cashback.title5') }}
						</h2>
						<div class="img_area_02">
							<img src="@/assets/images/sub/trade_and_cashback_03.png" alt="" />
						</div>
						<div class="text">
							<p class="body_m">
								{{ $t('rtr_personal-how-trade_and_cashback.text7') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.text8') }}
								{{ $t('rtr_personal-how-trade_and_cashback.text9') }}
								{{ $t('rtr_personal-how-trade_and_cashback.text10') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.text11') }}<br />
								{{ $t('rtr_personal-how-trade_and_cashback.text12') }}
							</p>
							<router-link to class="m_link_type_02" @click="notYet">
								{{ $t('rtr_personal-how-trade_and_cashback.text13') }}
								<span class="CIRCLE_ARROW"></span>
							</router-link>
						</div>
					</div>
				</div>
				<div class="detail_area">
					<div class="detail">
						<h2 class="headline_s">
							{{ $t('rtr_personal-how-trade_and_cashback.title6') }}
						</h2>
						<div class="img_area_02">
							<img src="@/assets/images/sub/trade_and_cashback_04.png" alt="" />
						</div>
						<div class="text">
							<p class="body_m">
								{{ $t('rtr_personal-how-trade_and_cashback.text14') }}<br />{{
									$t('rtr_personal-how-trade_and_cashback.text15')
								}}
								{{ $t('rtr_personal-how-trade_and_cashback.text16') }}
								{{ $t('rtr_personal-how-trade_and_cashback.text17') }}
							</p>
							<router-link to class="m_link_type_02" @click="notYet">
								{{ $t('rtr_personal-how-trade_and_cashback.text18') }}
								<span class="CIRCLE_ARROW"></span>
							</router-link>
						</div>
					</div>
				</div>
			</div>
		</section>
	</div>
</template>

<script>
import '@/assets/css/sub.m.css';
export default {
	name: 'TradeAndCashback.m',
	methods: {
		notYet() {
			alert(this.$t('alert.not_yet'));
		},
	},
};
</script>
<style scoped></style>
